import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setShowSuccess(true);
      setEmail('');
      setTimeout(() => setShowSuccess(false), 3000);
    }
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="contact" className="bg-[#0A0A0A] rounded-t-3xl">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div className="space-y-6">
            <h4 className="text-2xl font-bold text-white" style={{ fontFamily: 'Inter, sans-serif' }}>
              AUSTIN DRYWALL, LLC
            </h4>
            <p className="text-gray-400">Enterprise VPN Solutions</p>

            <form onSubmit={handleSubscribe} className="space-y-3">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="w-full px-4 py-3 bg-transparent border-2 border-[#06B6D4] rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-[#0891B2] transition-colors text-sm"
                required
              />
              <button
                type="submit"
                className="w-full px-6 py-3 bg-white text-[#0A1F44] rounded-lg font-semibold hover:bg-gray-100 transition-all flex items-center justify-center space-x-2 cursor-pointer whitespace-nowrap"
              >
                <span>Subscribe</span>
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
              {showSuccess && (
                <p className="text-[#06B6D4] text-sm">Thank you for subscribing!</p>
              )}
            </form>
          </div>

          <div className="space-y-6">
            <h5 className="text-lg font-semibold text-white">Quick Links</h5>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('features')}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer relative group"
                >
                  Features
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-white transition-all group-hover:w-full"></span>
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('security')}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer relative group"
                >
                  Security
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-white transition-all group-hover:w-full"></span>
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer relative group"
                >
                  About Us
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-white transition-all group-hover:w-full"></span>
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer relative group"
                >
                  Support
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-white transition-all group-hover:w-full"></span>
                </button>
              </li>
            </ul>
          </div>

          <div className="space-y-6">
            <h5 className="text-lg font-semibold text-white">Contact</h5>
            <div className="space-y-4">
              <a
                href="tel:+18665659830"
                className="flex items-center space-x-3 text-white hover:text-[#06B6D4] transition-colors cursor-pointer group"
              >
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-phone-line text-xl"></i>
                </div>
                <span>+1 866-565-9830</span>
              </a>
              <a
                href="mailto:information@austindrywallllc.com"
                className="flex items-start space-x-3 text-gray-400 hover:text-[#06B6D4] transition-colors cursor-pointer group"
              >
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <span className="break-all">information@austindrywallllc.com</span>
              </a>
            </div>

            <div className="pt-4">
              <h5 className="text-lg font-semibold text-white mb-4">Location</h5>
              <div className="flex items-start space-x-3 text-gray-400">
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <div>
                  <p>2534 William Ave</p>
                  <p>Holland, MI 49424, USA</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              © 2025 Austin Drywall, LLC. All rights reserved.
            </p>

            <div className="flex items-center space-x-6">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center text-gray-500 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center text-gray-500 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
            </div>

            <div className="flex items-center space-x-6">
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-white transition-colors text-sm cursor-pointer relative group"
              >
                Powered by Readdy
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-white transition-all group-hover:w-full"></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
